module.exports = __webpack_public_path__ + "static/media/banner-1.5382b539.jpg";